module.exports = __webpack_public_path__ + "img/code.14e02677.png";